import { render } from "./ReverseLogistics.vue?vue&type=template&id=3e6fef06&scoped=true"
import script from "./ReverseLogistics.vue?vue&type=script&lang=js"
export * from "./ReverseLogistics.vue?vue&type=script&lang=js"

import "./ReverseLogistics.vue?vue&type=style&index=0&id=3e6fef06&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6fef06"]])

export default __exports__